import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { FaChevronLeft } from 'react-icons/fa';
import envelope from 'assets/img/icons/spot-illustrations/16.png';

const ConfirmMailContent = ({ email, titleTag: TitleTag }) => (
  <>
    <img
      className="tw-block tw-mx-auto tw-mb-4"
      src={envelope}
      alt="sent"
      width={100}
    />
    <TitleTag>Please check your email!</TitleTag>
    <p>
      An email has been sent to <strong>{email}</strong>. Please click on the
      included link to reset your password.
    </p>
    <Link
      className="tw-inline-flex tw-items-center tw-gap-1.5 tw-px-2.5 tw-py-1.5 tw-rounded-sm tw-bg-blue-600 tw-text-white hover:tw-bg-blue-700 hover:tw-text-white tw-text-xs tw-no-underline tw-cursor-pointer tw-border-0 tw-mt-3"
      to="/authentication/login"
    >
      <FaChevronLeft className="tw-mr-1" />
      Return to login
    </Link>
  </>
);

ConfirmMailContent.propTypes = {
  email: PropTypes.string.isRequired,
  layout: PropTypes.string,
  titleTag: PropTypes.string
};

ConfirmMailContent.defaultProps = { layout: 'simple', titleTag: 'h4' };

export default ConfirmMailContent;
